import {CommissionSeance} from '../api/CommissionSeance';
import {Mandat} from '../api/Mandat';

export class ExComissionMandatStatut {
    public code = 0; //0 - 1 - 2
    public label = 'Terminé';
}

export class ExComissionMandat extends Mandat {
    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }
    }

    static isMandatCompatibleAvecCommissionSeance(mandat: Mandat, commissionSeance: CommissionSeance): boolean
    {
        const dateDebutMandat = new Date(mandat.dateDebut);
        const dateFinMandat = new Date(mandat.dateFin);

        const dateDebutReunion = new Date(commissionSeance.datetimeDebut);
        const dateFinReunion = new Date(commissionSeance.datetimeFin);

        return mandat.commission['id'] === commissionSeance.commission['id']
            && dateDebutMandat <= dateFinReunion
            && dateFinMandat >= dateDebutReunion;
    }

    /**
     * Renvoie {code : xx , label : xxx};
     *
     * @returns
     */
    public getStatus(): ExComissionMandatStatut {
        const dateDebut = new Date(this.dateDebut);
        const dateDuJour = new Date();
        const dateFin = new Date(this.dateFin);

        const statut = new ExComissionMandatStatut();
        if (dateDebut > dateDuJour) {
            statut.code = 0;
            statut.label = 'À venir';
        } else {
            if (dateFin >= dateDuJour) {
                statut.code = 1;
                statut.label = 'En cours';
            } else {
                statut.code = 2;
                statut.label = 'Terminé';
            }
        }

        return statut;
    }
}
